import React from 'react';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import styled, { css } from 'styled-components';
import { IdarkMode, IlightMode } from '../AgroIcon/icons';
var AgroToggleDarkMode = withCssProps(function (_ref) {
  var onChange = _ref.onChange,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? 'checkbox' : _ref$value,
    _ref$checked = _ref.checked,
    checked = _ref$checked === void 0 ? false : _ref$checked,
    className = _ref.className,
    disabled = _ref.disabled;
  var handleClick = function handleClick(event) {
    onChange({
      event: event,
      value: value
    });
  };
  return /*#__PURE__*/React.createElement(Toggle, {
    htmlFor: "checkbox",
    onClick: function onClick(e) {
      return handleClick(e);
    },
    className: className,
    disabled: disabled
  }, /*#__PURE__*/React.createElement("input", {
    readOnly: true,
    type: "checkbox",
    id: "checkbox",
    value: value,
    checked: checked
  }), /*#__PURE__*/React.createElement(Slider, {
    disabled: disabled,
    checked: checked
  }, checked ? /*#__PURE__*/React.createElement(SunIcon, {
    width: "14px",
    height: "14px",
    fill: "black"
  }) : /*#__PURE__*/React.createElement(MoonIcon, {
    width: "14px",
    height: "14px",
    fill: "white"
  })));
});
AgroToggleDarkMode.displayName = 'AgroToggleDarkMode';
export { AgroToggleDarkMode };
AgroToggleDarkMode.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool
};
var Toggle = styled.div.withConfig({
  displayName: "AgroToggleDarkMode__Toggle",
  componentId: "sc-3v7os4-0"
})(["display:inline-block;position:relative;height:24px;width:44px;> input{display:none;}", ""], function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && css(["pointer-events:none;"]);
});
var Slider = styled.div.withConfig({
  displayName: "AgroToggleDarkMode__Slider",
  componentId: "sc-3v7os4-1"
})(["background-color:transparent;border:1px solid ", ";box-sizing:border-box;cursor:pointer;position:absolute;bottom:0;left:0;right:0;top:0;transition:0.4s;border-radius:100px;&:before{content:'';border-radius:50%;background-color:", ";position:absolute;bottom:4px;left:4px;height:14px;width:14px;transition:0.3s;}", " ", ""], function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.white;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, function (_ref5) {
  var checked = _ref5.checked,
    theme = _ref5.theme;
  return checked && css(["background-color:", ";&:before{background-color:", ";transform:translateX(18px);}"], theme.colors.white, theme.colors.black);
}, function (_ref6) {
  var checked = _ref6.checked,
    disabled = _ref6.disabled;
  return disabled && css(["pointer-events:none;background-color:", ";"], function (_ref7) {
    var theme = _ref7.theme;
    return checked ? '#dae7c9' : theme.colors.gray300;
  });
});
var MoonIcon = styled(IdarkMode).withConfig({
  displayName: "AgroToggleDarkMode__MoonIcon",
  componentId: "sc-3v7os4-2"
})(["position:absolute;bottom:4px;right:4px;"]);
var SunIcon = styled(IlightMode).withConfig({
  displayName: "AgroToggleDarkMode__SunIcon",
  componentId: "sc-3v7os4-3"
})(["position:absolute;bottom:4px;left:4px;"]);